<template>
  <div class="fixed-bottom bg-white">
    <hr class="m-0" />
    <footer class="spotlight-footer">
      <div class="footer-inner">
        <mobialis-button class="mb-3 get-report-button" data-cy="getReport" :size="buttonSize" @click="getReport">{{
          $t('message.spotlightV2.footer.buttonText')
        }}</mobialis-button>
      </div>
    </footer>
  </div>
</template>

<script>
import log from '@/services/log';

export default {
  name: 'GetReportFooter',
  computed: {
    buttonSize() {
      return this.currentScreenMediaQuery === 'desktop' ? 'btn-lg' : 'btn-md';
    },
  },
  methods: {
    getReport() {
      // Analytics tracking
      const payload = {
        elementInteractedWith: 'spotlight.get-report.click',
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });

      this.$router.push(`/${this.baseRoute}/spotlight/get-report`);
    },
  },
};
</script>

<style scoped lang="scss">
.footer-inner {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  padding: 24px 20px 10px;
}
</style>
